module.exports = __webpack_public_path__ + "img/bureau-red.b2049d18.png";